import { all, fork } from 'redux-saga/effects';

import userSaga from 'actions/users';
import streamsSaga from 'actions/streams';
import collectionsSaga from 'actions/collections';
import assetsSaga from 'actions/assets';
import integrationsSaga from 'actions/integrations';
import linksSaga from 'actions/links';
import seekSaga from 'actions/seek';
import loginSaga from 'actions/login';
import conversationsSaga from 'actions/conversations';
import eventsSaga from 'actions/adoption';
import meetingSaga from 'actions/meeting';


export default function* root() {
  yield all([
    fork(userSaga),
    fork(streamsSaga),
    fork(collectionsSaga),
    fork(assetsSaga),
    fork(integrationsSaga),
    fork(linksSaga),
    fork(seekSaga),
    fork(loginSaga),
    fork(conversationsSaga),
    fork(eventsSaga),
    fork(meetingSaga),
  ]);
}